import { throwError as observableThrowError, Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class InviteService {
  constructor(private http: HttpClient) {}
   public InviteUsers (email_list, fileName, message1: string, message2: string): Observable<any> {
     const data = new FormData();
     data.append('email_list', email_list);
     data.append('file', fileName);
     data.append('message', message1);
     data.append('message2', message2);
    return this.http.post('/api/1/admin/invite/users/', data).pipe(map(function(res: any) {
      return res;
    }),catchError(this.handleError),);
  }
  public handleError = (error: any) => {
    let errMsg: string;
    //! not sure if it works
    if (error.status) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    return observableThrowError(errMsg);
  }
}

